import axios from "../../../axios"
import { getCurrentTenant, formatGraphqlBody } from '@/utils'

export default {
    fetch: (sortName = "id", page, itemsPerPage, type = "DESC", word = "") => {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', formatGraphqlBody(
            'query',
            'getService',
            {
                0: 'pagination_page',
                1: 'pagination_limit',
                2: 'total_pages',
                3: 'total_items',
                items: {
                    0: 'id',
                    1: 'name',
                    2: 'price',
                    3: 'category',
                    4: 'description',
                    5: 'recurrence'
                }
            },
            {
                orderBy: [sortName, type],
                search_filter: word,
                pagination_page: page,
                pagination_limit: itemsPerPage
            }
        ));
    },
    create: (data) => {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                mutation {
                    createService 
                    (
                        name: "${data.name}",
                        price: ${data.price},
                        category: "${data.category}",
                        description: """${data.description}""",
                        recurrence: "${data.recurrence}"
                    ) {
                        id,
                        name,
                        price,
                        category,
                        description,
                        recurrence
                    }
                }
            `
        });
    },
    update: (data) => {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                mutation {
                    updateService 
                    (
                        id: ${data.id},
                        name: "${data.name}",
                        price: ${data.price},
                        category: "${data.category}",
                        description: """${data.description}""",
                        recurrence: "${data.recurrence}"
                    ) {
                        id,
                        name,
                        price,
                        category,
                        description,
                        recurrence
                    }
                }
            `
        });
    },
    delete: (id) => {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                mutation {
                    deleteService (
                        id: ${id}
                    )
                }
            `
        });
    }
}